import { type FC } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { HasFeatureFlag } from '@/src/features/integrations/statsig/components/HasFeatureFlag';

export const ObserverNavLinks: FC = () => (
  <HasFeatureFlag.DashboardMetabase>
    <SideNavButton icon={DashboardOutlined} page='dashboard'>
      Dashboard
    </SideNavButton>
  </HasFeatureFlag.DashboardMetabase>
);
